import { render, staticRenderFns } from "./supportedWallets.vue?vue&type=template&id=51e43f3f&scoped=true"
import script from "./supportedWallets.vue?vue&type=script&lang=js"
export * from "./supportedWallets.vue?vue&type=script&lang=js"
import style0 from "./supportedWallets.vue?vue&type=style&index=0&id=51e43f3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e43f3f",
  null
  
)

export default component.exports